import { render, staticRenderFns } from "./merchantExamine.vue?vue&type=template&id=5c1c1bed&"
import script from "./merchantExamine.vue?vue&type=script&lang=js&"
export * from "./merchantExamine.vue?vue&type=script&lang=js&"
import style0 from "./merchantExamine.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports